import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {useState} from "react";
import {FormContainer} from "../../../../palette/Palette";
import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    RequiredRule,
    EmailRule
} from 'devextreme-react/form';
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {Button} from "devextreme-react/button";
import {db} from "../../../../firebase/Firebase";
import {
    ErrorMessage,
    NotiStackInfo
} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import Results from "../../../../palette/Results";

const passwordOptions = {
    mode: 'password',
    disabled: true,
    value: '**********'
};

const roles = ['Administrador', 'Usuario']

function UsersEditForm(props) {

    const {dataSource, setEdit, setTrigger, trigger, setVisibleGrid} = props

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess, text: 'Actualizar datos de usuario', icon: 'far fa-edit'
    })
    const [load, setLoad] = useState(true)
    const [result, setResult] = useState(null)

    const {enqueueSnackbar} = useSnackbar();

    const alertsRender = () => {
        return (
            <Results results={result} text={'Datos de usuario actualizados exitosamente'}/>
        )
    }

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        setEdit(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        let role;
        if (dataSource.role === 'Usuario') {
            role = 'user'
        } else {
            role = 'sroot'
        }

        setSubmitButton({...submitButton, disabled: true})
        setLoad(false)

        let status;
        status = dataSource.status === 'Cuenta activa';

        const data = {...dataSource, role: role, status: status}
        const docId = data.id
        delete data.id


        await db.collection("Users").doc(docId).set(data)
            .then(() => {
                setSubmitButton({...submitButton, disabled: false})
                setResult('OK')
                setLoad(true)
                setTimeout(() => {
                    setResult(null)
                    setEdit(false)
                    setVisibleGrid(true)
                }, 1500)
                setTrigger(!trigger)
            }).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setSubmitButton({...submitButton, disabled: false})
                setEdit(false)
            })
    }


    return (
        <>
            <VerticalSpace space={30}/>
            <div className="crete-users-container">
                <HeaderPage icon={'far fa-edit'} text={'Editar usuario'} load={load} textLoad={'Actualizando...'}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            formData={dataSource}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="editUsers"
                        >
                            <GroupItem caption="Credenciales" colCount={1} colSpan={1}>
                                <SimpleItem dataField="username" label={{text: 'Nombre o cargo'}}
                                            editorOptions={{maxLength: 70}}>
                                    <RequiredRule message="El nombre de usuario es requerido!"/>
                                </SimpleItem>
                                <SimpleItem dataField="userEmail" label={{text: 'Correo electrónico'}}
                                            editorOptions={{disabled: true}}>
                                    <EmailRule message="Correo electrónico invalido"/>
                                    <RequiredRule message="Ingrese el Correo electrónico de usuario"/>
                                </SimpleItem>
                                <SimpleItem dataField="password" label={{text: 'Contraseña'}}
                                            editorOptions={passwordOptions}/>
                                <SimpleItem dataField="role" label={{text: 'Rol de usuario'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                items: roles,
                                                value: dataSource.role === 'sroot' ? 'Administrador' : 'Usuario',
                                                placeholder: 'Seleccionar..'
                                            }}
                                >
                                    <RequiredRule message="Seleccione el rol de usuario"/>
                                </SimpleItem>
                                {result && <SimpleItem render={alertsRender}/>}
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>
                </FormContainer>
            </div>
        </>
    )
}

export default UsersEditForm